var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgReceipt = function SvgReceipt(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6 8H12M6 12H12M6 16H12M16.5 8H18M16.5 12H18M16.5 16H18M21 0.75L18 3.75L15 0.75L12 3.75L9 0.75L6 3.75L3 0.75V23.25L6 20.25L9 23.25L12 20.25L15 23.25L18 20.25L21 23.25V0.75Z",
    stroke: "currentColor",
    strokeWidth: 1.71429,
    vectorEffect: "non-scaling-stroke",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};

export { SvgReceipt as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KICAgIDxwYXRoIGQ9Ik02IDhIMTJNNiAxMkgxMk02IDE2SDEyTTE2LjUgOEgxOE0xNi41IDEySDE4TTE2LjUgMTZIMThNMjEgMC43NUwxOCAzLjc1TDE1IDAuNzVMMTIgMy43NUw5IDAuNzVMNiAzLjc1TDMgMC43NVYyMy4yNUw2IDIwLjI1TDkgMjMuMjVMMTIgMjAuMjVMMTUgMjMuMjVMMTggMjAuMjVMMjEgMjMuMjVWMC43NVoiCiAgICAgICAgICBzdHJva2U9ImN1cnJlbnRDb2xvciIgc3Ryb2tlLXdpZHRoPSIxLjcxNDI5IiB2ZWN0b3ItZWZmZWN0PSJub24tc2NhbGluZy1zdHJva2UiIHN0cm9rZS1saW5lY2FwPSJyb3VuZCIKICAgICAgICAgIHN0cm9rZS1saW5lam9pbj0icm91bmQiLz4KPC9zdmc+Cg==";